package gr.tech.GRAttestation.styles

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.layer.SilkLayer
import com.varabyte.kobweb.silk.style.layer.add
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.*

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    ctx.stylesheet.cssLayers.add("BootstrapCSS", after = SilkLayer.BASE)
    ctx.stylesheet.cssLayers.add("Overrides", after = "BootstrapCSS")

//    ctx.stylesheet.registerStyleBase("html") {
//        Modifier
//            .scrollBehavior(ScrollBehavior.Smooth)
//    }
//
//    ctx.stylesheet.registerStyleBase("h1") {
//        Modifier
//            .fontFamily(FONT_FAMILY)
//            .fontSize(2.cssRem)
//            .fontWeight(FontWeight.Bold)
//            .lineHeight(1.5)
//    }
//
//    ctx.stylesheet.registerStyleBase("h2") {
//        Modifier
//            .fontFamily(FONT_FAMILY)
//            .fontSize(1.5.cssRem)
//            .fontWeight(FontWeight.Bold)
//            .lineHeight(1.5)
//    }
//
//    ctx.stylesheet.registerStyleBase("h3") {
//        Modifier
//            .fontFamily(FONT_FAMILY)
//            .fontSize(1.17.cssRem)
//            .fontWeight(FontWeight.Bold)
//            .lineHeight(1.5)
//    }
//
//    ctx.stylesheet.registerStyleBase("p") {
//        Modifier
//            .fontFamily(FONT_FAMILY)
//            .fontSize(1.cssRem)
//            .lineHeight(1.5)
//    }

    // Silk dividers only extend 90% by default; we want full width dividers in our site
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth().borderTop(1.px, LineStyle.Solid, Colors.Black)
    }
}

fun Modifier.defaultText(): Modifier {
    return this
        .fontFamily(FONT_FAMILY)
        .fontSize(1.cssRem)
        .fontWeight(FontWeight.Normal)
}

@Composable
fun Modifier.errorText(): Modifier {
    return this
        .then(Modifier.fontFamily(FONT_FAMILY))
        .classNames("form-text", "text-danger", "small", "my-1")
}

fun Modifier.noBorder(): Modifier {
    return this
        .border (
            width = 0.px,
            style = LineStyle.None,
            color = Colors.Transparent
        )
        .outline(
            width = 0.px,
            style = LineStyle.None,
            color = Colors.Transparent
        )
}

fun Modifier.skinnyCappedWidth(): Modifier {
    return this
        .width(min(834.px, 100.percent))
}

fun Modifier.wideCappedWidth(): Modifier {
    return this
        .width(min(1484.px, 100.percent))
}

val ResponsiveDualColumn = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .justifyContent(JustifyContent.Center)
    }
    Breakpoint.LG {
        Modifier
            .flexDirection(FlexDirection.Row)
            .justifyContent(JustifyContent.SpaceBetween)
    }
}

val LoadingSkeleton = CssStyle {
    base {
        Modifier
            .classNames("is-skeleton")
    }
}

